module.exports = __webpack_public_path__ + "vue-app/img/logo-tl-fr.7a9db052.png";